import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const MultiStoryPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Multi-Story Drone Window Cleaning - Flyby Shine</title>
                        <meta name="description" content="Utilizing state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for multi-story buildings." />
                        <meta name="keywords" content="Multi-Story Drone Window Cleaning, Drone cleaning services, commercial drone cleaning, industrial drone cleaning, hygienic drone cleaning, expert drone cleaning services, safe drone cleaning, thorough drone cleaning, professional drone cleaning, reliable drone cleaning, top-quality drone cleaning, drone cleaning services, drone cleaning solutions, drone cleaning experts" />
                        <meta property="og:image" content="/assets/multistory.png" />
                    </>
                )}
            </MetaTagHandler>

            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Multi-Story Window Cleaning'}
                    description={`Utilizing state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for multi-story buildings. `}
                    banner={{ image: '/assets/multistory.png', alt: 'A multistory building cleaned by drone' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for multi-story buildings.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Window cleaning is a breeze with our advanced drone technology. Our drones can reach high areas safely and efficiently, providing a thorough cleaning solution for multi-story buildings."}
                    subTitle={"Multi-Story Window Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Safe: No more ladders or platforms</li>
                                <li><i className="material-icons">check_circle_outline</i>Reach Inaccessible Areas</li>
                            </ul>
                        </div>
                    }
                    images={[

                        {
                            firstImage: {
                                imageUrl: '/assets/commercialBefore.jpg',
                            },
                            secondImage: {
                                imageUrl: '/assets/commercialAfter.jpeg',
                            }
                        }

                    ]}

                />

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/highrisedrone.png', alt: 'nationwide about us image' }}
                        title={'Minimized Risk of Property Damage'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'protecting your property icon' }}
                        description={'Our drone cleaning technology allows for controlled pressure application tailored to different surfaces, minimizing the risk of damage to your valuable property.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. We customize our approach to fit your specific requirements, ensuring optimal results for every job.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/windowclean.mp4',

                        }}
                        title={'Advanced Drone Technology'}
                        heading={{ image: '/assets/water.svg', alt: 'water icon' }}
                        description={'Our advanced drone technology allows us to reach high areas safely and efficiently, providing a thorough cleaning solution for every window.'}
                    />
                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default MultiStoryPage
